import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { useDispatch } from 'react-redux';
import * as employeeApi from '../../../lib/api/employee';
import CareerSchoolForm from '../../../components/employeemng/personal/CareerSchoolForm';
import { listCareerSchool } from '../../../modules/empModule/empPersonal';



const CareerSchoolFormContainer = ({ employee }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    attrVal1: '',
    attrVal2: '',
    attrVal3: '',
    attrVal4: '',
  };

  const validationSchema = yup.object({
    attrVal1: yup.string('').required('학교명을 입력하세요'),
    attrVal2: yup.string().required('학과를 입력하세요'),
    attrVal3: yup.string().required('졸업일자를 입력하세요'),
    attrVal4: yup.string().required('졸업여부를 입력하세요'),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        usrUuid: employee.usrUuid,
        infoTyp: 'CAREER_SCHOOL',
        attrVal1: values.attrVal1,
        attrVal2: values.attrVal2,
        attrVal3: values.attrVal3,
        attrVal4: values.attrVal4,
      };

      //console.log(JSON.stringify(dataToSubmit),'dataToSubmit');

      try {
        const response = await employeeApi.addResumeByEmp(dataToSubmit);
        if (response.data) {
          dispatch(
            listCareerSchool({
              id: employee.usrUuid,
              infoTyp: 'CAREER_SCHOOL',
            }),
          );
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      formik.resetForm();
      setSubmitting(false);
    },
  });

  return <CareerSchoolForm formik={formik} />;
};

export default CareerSchoolFormContainer;
